<div class="tooltip" role="tooltip"
     [ngStyle]="{top: top, left: left, display: display}"
     [ngClass]="classMap">
    <div class="tooltip-arrow"></div>
    <div class="tooltip-inner"
         *ngIf="htmlContent && !isTemplate"
         innerHtml="{{htmlContent}}">
    </div>
    <div class="tooltip-inner"
         *ngIf="htmlContent && isTemplate">
        <ng-template [ngTemplateOutlet]="htmlContent"
                     [ngTemplateOutletContext]="{model: context}">
        </ng-template>
    </div>
    <div class="tooltip-inner"
         *ngIf="content">
      {{content}}
    </div>
</div>